import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import {
  PositionApplicationCharCountText,
  PositionApplicationSubBtn,
  PositionApplicationStepTitleText,
  PositionApplicationMainBtn,
  PositionApplicationTempSavingTag,
  PositionApplicationFormContainer,
  PositionApplicationTextArea,
  PositionApplicationTextAreaContainer,
  PositionApplicationStepSubText,
  PositionApplicationFormContentContainer,
} from 'containers/positions/application/styles'
import { Column, Row } from 'components/common/layout'
import { PositionApplicationStore } from 'stores/position-application'
import { useDebounce } from 'utils/hooks'
import { detectAndNoticePrivateInfoFromApplication } from 'utils/handlers'
import { APPLICATION_MESSAGE_MAX_LENGTH } from 'infra/constants'

export const PositionApplicationJoinReasonStep: React.FC<{
  store: PositionApplicationStore
}> = observer(({ store }) => {
  const saveTempJoinReason = useDebounce(1000, async (v: string) => {
    await store.saveTempWithErrorHandling({ joinReason: v })
    store.setState('isSavingJoinReason', false)
  })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => store.setState('curTab', 1), [])

  const clickNext = async () => {
    if (!store.joinReason) return store.moveNextStep()
    try {
      if (store.isSavingJoinReason) return
      store.setState('isSavingJoinReason', true)
      const hasDetected = await detectAndNoticePrivateInfoFromApplication(
        store.positionDetail?.id || 0,
        { joinReason: store.joinReason },
      )
      // 1. 탐지된 게 없으면 다음으로 넘어감
      if (!hasDetected) {
        store.setState('isSavingJoinReason', false)
        return store.moveNextStep()
      }
      // 2. 탐지된 게 있으면 mutate한 데이터로 업데이트
      store.mutateAndUpdateTemp()
    } catch (e) {
      alert(e)
    }
    store.setState('isSavingJoinReason', false)
  }

  return (
    <PositionApplicationFormContainer>
      <PositionApplicationFormContentContainer>
        <Column style={{ gap: 4 }}>
          <PositionApplicationStepTitleText>
            스타트업에 합류하고 싶은 이유를 알려주세요
          </PositionApplicationStepTitleText>
          <PositionApplicationStepSubText>
            매력을 느낀 부분이나, 기여하고 싶은 바를 작성해 보세요
          </PositionApplicationStepSubText>
        </Column>
        <PositionApplicationTextAreaContainer>
          <PositionApplicationTextArea
            value={store.joinReason || ''}
            placeholder={`‧ 채용 공고의 어떤 부분이 매력적으로 느껴졌는지 알려주세요\n‧ ${store.startupDetail?.name}에 관심을 가지게 된 이유를 작성해도 좋아요`}
            maxLength={APPLICATION_MESSAGE_MAX_LENGTH}
            onChange={(e) => {
              if (e.target.value.length > APPLICATION_MESSAGE_MAX_LENGTH) return
              store.setState('isSavingJoinReason', true)
              store.setState('joinReason', e.target.value)
              saveTempJoinReason(e.target.value)
            }}
          />
          <Row style={{ height: 30 }}>
            {store.isSavingJoinReason && (
              <PositionApplicationTempSavingTag>
                임시 저장 중
              </PositionApplicationTempSavingTag>
            )}
            <PositionApplicationCharCountText>
              {store.joinReason?.length || 0}/{APPLICATION_MESSAGE_MAX_LENGTH}
            </PositionApplicationCharCountText>
          </Row>
        </PositionApplicationTextAreaContainer>
      </PositionApplicationFormContentContainer>
      <Row style={{ gap: 8 }}>
        <PositionApplicationSubBtn onClick={() => store.movePrevStep()}>
          이전
        </PositionApplicationSubBtn>
        <PositionApplicationMainBtn onClick={clickNext}>
          다음
        </PositionApplicationMainBtn>
      </Row>
    </PositionApplicationFormContainer>
  )
})
